/* eslint-disable @typescript-eslint/no-explicit-any */
export class CommonUtils {
  static isNullOrUndefined(input: any): boolean {
    return input === undefined || input === null;
  }
}
